import {
    all,
    take,
    takeEvery,
    takeLatest,
    select,
    apply,
    put,
    call,
} from 'redux-saga/effects';

import {
    ATTEMPT_CREATE_BLOCK,
    ATTEMPT_SAVE_BLOCK,
    ATTEMPT_MOVE_BLOCK,
    ATTEMPT_DELETE_BLOCK,

    QUEUE_ITEM_SUCCEEDED,
    QUEUE_ITEM_FAILED,
} from 'shared_redux/actions';
import API from 'services/blocks';
import { handleError } from 'services/alerts';

export default function* BlocksSaga() {
    yield all([
        takeEvery(ATTEMPT_CREATE_BLOCK, createBlock),
        takeEvery(ATTEMPT_SAVE_BLOCK, saveBlock),
        takeEvery(ATTEMPT_MOVE_BLOCK, moveBlock),
        takeEvery(ATTEMPT_DELETE_BLOCK, deleteBlock),
    ]);
};

function *createBlock(action) {
    try {
        yield apply(API, API.createBlock, [action.payload]);
        yield put({ type: QUEUE_ITEM_SUCCEEDED });
    } catch(error) {
        if (error.statusCode === 409) {
            // already created, treat as success
            yield put({ type: QUEUE_ITEM_SUCCEEDED });
        } else {
            yield put({ type: QUEUE_ITEM_FAILED });
            yield handleError(error, 'Error: Unable to create block');
        }
    }
}

function *saveBlock(action) {
    try {
        yield apply(API, API.updateBlock, [action.payload]);
        yield put({ type: QUEUE_ITEM_SUCCEEDED });
    } catch(error) {
        yield put({ type: QUEUE_ITEM_FAILED });
        yield handleError(error, 'Error: Unable to save block');
    }
}

function *moveBlock(action) {
    try {
        yield apply(API, API.updateBlock, [action.payload]);
        yield put({ type: QUEUE_ITEM_SUCCEEDED });
    } catch(error) {
        yield put({ type: QUEUE_ITEM_FAILED });
        yield handleError(error, 'Error: Unable to move block');
    }
}

function *deleteBlock(action) {
    try {
        yield apply(API, API.deleteBlock, [action.id]);
        yield put({ type: QUEUE_ITEM_SUCCEEDED });
    } catch(error) {
        if (error.statusCode === 403) {
            // POSSIBLY already deleted, going to assume it and treat it as success
            yield put({ type: QUEUE_ITEM_SUCCEEDED });
        } else {
            yield put({ type: QUEUE_ITEM_FAILED });
            yield handleError(error, 'Error: Unable to delete block');
        }
    }
}
